export const znjcIndexObj= {
  "0":{
    text:"血压",
    img:require("../assets/images/back/znjc_xy.png")
  },
  "1":{
    text:"血糖",
    img:require("../assets/images/back/znjc_xt.png")
  },
  "2":{
    text:"总胆固醇",
    img:require("../assets/images/back/znjc_zdgc.png")
  },
  "3":{
    text:"血尿酸",
    img:require("../assets/images/back/znjc_xns.png")
  },
  "4":{
    text:"心率",
    img:require("../assets/images/back/znjc_xy.png")
  },
  "5":{
    text:"血氧",
    img:require("../assets/images/back/znjc_xo.png")
  },
};
export const znjcIndexObj1=2;



// WEBPACK FOOTER //
// ./src/api/znjcIndex.js